import "./styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./app.tsx";
import { LocaleProvider } from "./locale/locale-context.tsx";
import { AuthProvider } from "./auth/auth-context.tsx";

// Lock the customer site to light theme — the mockup is explicitly light.
// Dark surfaces (Trending band, FeaturedSeriesBlock) are scoped per-section
// via local data-theme="dark" wrappers when needed.
document.documentElement.setAttribute("data-theme", "light");

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <LocaleProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </LocaleProvider>
    </BrowserRouter>
  </StrictMode>,
);
